import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import { IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Icon } from 'src/components/Icon';
import { Stack } from 'src/components/Stack';
import { FormTextField } from 'src/shared/Forms/Fields/FormTextField';

import TrainerPermissions from '../NewStaff/TrainerPermissions';

interface RoleEditorProps {
  onDelete: () => void;
  canEdit: boolean;
  index: number;
}

export const RoleEditor = ({ onDelete, canEdit, index }: RoleEditorProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'staff.rolesManagement',
  });

  const roleFieldName = `defaultChildPlatformRoles.${index}`;
  const nameFieldName = `${roleFieldName}.name`;
  const permissionsFieldName = `${roleFieldName}.permissions`;

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        p: 2,
      }}
    >
      <Stack spacing={2}>
        {/* Role Header */}
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <FormTextField
            name={nameFieldName}
            placeholder={t('roleNamePlaceholder')}
            disabled={!canEdit}
            sx={{ minWidth: 200, flex: 1 }}
          />

          {canEdit && (
            <IconButton size="small" color="error" onClick={onDelete}>
              <Icon icon={icon({ name: 'trash' })} />
            </IconButton>
          )}
        </Stack>

        {/* Role Permissions */}
        <TrainerPermissions namePrefix={permissionsFieldName} />
      </Stack>
    </Box>
  );
};
